import {
  string,
  bool,
  node,
  func,
  oneOf,
  elementType,
  oneOfType,
} from 'prop-types';
import styled from 'styled-components';
import ReactModal from 'react-modal';
import Button from '../StoraEnsoComponents/Button';
import Icon from '../StoraEnsoComponents/Icon';
import themeObj from '../../config/theme';

const modalStyle = {
  overlay: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    backgroundColor: 'rgba(0, 0, 0, 0.45)',
    zIndex: 9999,
  },
  content: {
    padding: '0',
    top: 'auto',
    bottom: 'auto',
    margin: 'auto',
    backgroundColor: themeObj.colors.white,
    border: '0 none',
    borderRadius: '0',
    display: 'grid',
  },
};

const modalSize = ({ size }) =>
  ({
    sm: {
      width: 'calc(100% - 80px)',
      maxWidth: '500px',
      maxHeight: '80vh',
    },
    md: {
      width: 'calc(100% - 80px)',
      maxWidth: '700px',
      maxHeight: '80vh',
    },
    lg: {
      width: 'calc(100% - 80px)',
      maxWidth: '1600px',
      maxHeight: '80vh',
    },
  }[size]);

const IconWrapper = styled.div`
  ${Icon} {
    /* color: ${({theme}) => theme.colors.white}; */
    font-size: 12px;
    cursor: pointer;
  }
`;

const ModalWrapper = styled.div`
  display: grid;
  grid-template-rows: auto 1fr auto;
  height: 100%;
`;

const ModalHeader = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 0.5em 1em;
  background-color: ${({theme}) => theme.colors.bg_gray_light};
`;

const Title = styled.div`
  /* color: ${({ theme }) => theme.colors.white}; */
  font-weight: bold;
  line-height: 1.25;
`;

const ModalBody = styled.div`
  padding: 1em;
  max-height: calc(80vh - 92px); /* max Modal height - height of header and footer */
  overflow: auto;
`;

const ModalFooter = styled.div`
  padding: 0.25rem;
  /* border-top: 1px solid ${({ theme }) => theme.colors.medium_bg}; */
  color: ${({ theme }) => theme.colors.medium_text};
  background-color: ${({theme}) => theme.colors.bg_gray_light};
`;

const FooterContent = styled.div`
  display: grid;
  grid-template-columns: 1fr auto;
`;

const CustomFooterContentWrapper = styled.div``;

const ButtonWrapper = styled.div`
  align-content: flex-end;

  ${Button} {
    margin-left: 0.5rem;
  }
`;

const Content = styled.div`
`;

function Modal ({
  modalId,
  size,
  isOpen,
  title,
  children,
  // isClosable,
  onClose,
  onSubmit,
  submitBtnLabel,
  cancelBtnLabel,
  cancelDisabled,
  submitDisabled,
  customFooterContent,
  onlyCloseBtn,
  showFooter,
}) {

  const customStyle = {
    ...modalStyle,
    content: {
      ...modalStyle.content,
      ...modalSize({ size }),
    },
  };

  return (
    <ReactModal
      isOpen={isOpen}
      style={customStyle}
      shouldCloseOnOverlayClick={true}
      shouldCloseOnEsc={true}
      onRequestClose={onClose}
    >
      <ModalWrapper id={modalId}>
        <ModalHeader>
          <Title>{title}</Title>
          <IconWrapper>
            <Icon role="button" onClick={onClose}>close</Icon>
          </IconWrapper>
        </ModalHeader>
        <ModalBody>
          <Content>
            {children}
          </Content>
        </ModalBody>

        {
          showFooter && (
            <ModalFooter>
              <FooterContent>
                <CustomFooterContentWrapper>
                  {customFooterContent}
                </CustomFooterContentWrapper>
                <ButtonWrapper>
                  <Button onClick={onClose} kind={onlyCloseBtn ? 'primary' : 'secondary'} isFlat disabled={cancelDisabled}>{cancelBtnLabel}</Button>
                  {
                    !onlyCloseBtn && (
                      <Button onClick={onSubmit} disabled={submitDisabled} isFlat>{submitBtnLabel}</Button>
                    )
                  }
                </ButtonWrapper>
              </FooterContent>
            </ModalFooter>
          )
        }

      </ModalWrapper>
    </ReactModal>
  );
};

Modal.propTypes = {
  modalId: string,
  size: oneOf(['sm', 'md', 'lg']),
  isOpen: bool.isRequired,
  title: oneOfType([elementType, node]).isRequired,
  children: node.isRequired,
  isClosable: bool,
  onClose: func,
  onSubmit: func,
  submitBtnLabel: string,
  cancelBtnLabel: string,
  cancelDisabled: bool,
  submitDisabled: bool,
  customFooterContent: node,
  onlyCloseBtn: bool,
  showFooter: bool,
};

Modal.defaultProps = {
  modalId: '',
  size: 'md',
  isClosable: true,
  submitBtnLabel: 'Ok',
  cancelBtnLabel: 'Cancel',
  cancelDisabled: false,
  submitDisabled: false,
  customFooterContent: undefined,
  onlyCloseBtn: false,
  showFooter: true,
  onSubmit: () => {},
  onClose: () => {},
};

export default Modal;
